import type UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import AbstractSignupScreen from './AbstractSignupScreen';
import type { UnifiedSignupScreenName } from '../UnifiedSignupScreenName';

export default class SignupSuccessRedirectSignupScreen extends AbstractSignupScreen {
  public readonly screenName: UnifiedSignupScreenName = 'uss-signup-success-signin-redirect';

  public getVisibleComponents(): UnifiedSignupScreenComponent[] {
    return [];
  }

  public getValidatedComponents(): UnifiedSignupScreenComponent[] {
    return this.getVisibleComponents();
  }

  public predicate(): boolean {
    const { submitFormResult } = this.sessionInfo.value;

    if (!submitFormResult || submitFormResult.statusCode !== 202) {
      return false;
    }

    return true;
  }

  public async toNextScreen(): Promise<boolean> {
    return false;
  }

  public getProgress(): number {
    return 100;
  }
}
